import React, { PureComponent } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { number, string, array } from 'prop-types';
import DateTime from '../../../../components/DateTime/DateTime';
import CopyContent from '../../../../components/common/CopyContent';

class PostbackLogsItem extends PureComponent {
  static propTypes = {
    hash: string,
    its: number,
    url: string,
    method: string,
    received: string,
    status: string,
    data: array,
  };

  showMore = data => {
    this.props.onShowMore(data);
  };

  formatToResponse = (data = {}) =>
    Object.keys(data).reduce((values, i) => {
      if (data[i].key && data[i].value) {
        return `${values}${data[i].key} = ${data[i].value}\r\n`;
      }

      return values;
    }, '');

  _slice = (str = '') => (
    <span>
      {str.length >= 30 ? str.slice(0, 30).trim() : str}
      &hellip;
    </span>
  );

  renderNormalizeData = data => (
    <code className="response-preview" onClick={() => this.showMore(data)}>
      {this._slice(data)}
    </code>
  );

  normalizeData = data => {
    switch (typeof data) {
      case 'object':
        const formatted = this.formatToResponse(data);
        return this.renderNormalizeData(formatted);
      case 'string':
        return this.renderNormalizeData(data);
      default:
        return data;
    }
  };

  // getLeadId = data => {
  //   const lead = data.find(({key}) => key === 'lead_id');
  //   return lead ? lead.value : null;
  // }

  render() {
    const { hash, settings, its, url, received = '', status, data, method } = this.props;
    return (
      <tr>
        {settings.hash && <td>{hash}</td>}
        {settings.leadID && <td>{data.filter(item => item.key === 'lead_id')[0].value}</td>}
        {settings.date && <td>
          <DateTime timestamp={its} />
        </td>}
        {settings.url && <td className='postback-logs-table-item-url'>
          <span id={`postback-log-${hash}`}>{this._slice(url)}</span>
          <UncontrolledTooltip placement="top" target={`postback-log-${hash}`}>
            {url}
          </UncontrolledTooltip>
          <CopyContent
            content={url}
            iconType='link'
            copyMessageId='flows.table.click-link'
            tooltipMessageId='flow.form.link.copy'
            tooltipTargetId={`postback-log-${hash}_`}
          />
        </td>}
        {settings.sended && <td>{this.normalizeData(data)}</td>}
        {settings.method && <td>{method}</td>}
        {settings.received && <td>{received}</td>}
        {settings.status && <td>{status}</td>}
        {/* <td>{this.getLeadId(data)}</td> */}
      </tr>
    );
  }
}

export default PostbackLogsItem;
